<template>
  <div name="register_import">

    <transition name="modal">
      <div
        class="modal-mask fixed top-0 left-0 w-full h-full outline-none fade"
      >
        <div
          class="
            modal-container
            w-11/12
            mt-5
            mb-10
            mx-auto
            rounded
            shadow-lg
            z-50
            h-full
            bg-white
          "
        >
          <header class="h-12 p-4 pt-10 pb-8 w-11/12 mx-auto">
            <i
              class="
                fas
                fa-times-circle
                cursor-pointer
                fixed
                right-0
                items-center
                mt-0
                rounded-2
                mr-40
                text-black text-4xl
                z-50
              "
              @click="$emit('close')"
              style="right: -12px"
            ></i>
            <h1 class="text-gray-700 font-bold text-4xl">Import Pupils {{school.name}}</h1>
          </header>
          <div class="h-3/4 overflow-y-auto w-11/12 mx-auto mt-16 pb-20">

            <slot name="body">
              <div class="row">
                <div class="col-md-12" v-show="isDisabled">
<vue-csv-import v-model="parseCsv" :map-fields="['name', 'year', 'group', 'gender', 'ethnicity', 'esl', 'sen', 'premium']" 
:autoMatchFields=true :autoMatchIgnoreCase=true :canIgnore=true :headers=true
 inputClass="import" tableSelectClass="import-select" tableClass="import-table" loadBtnText="Click to map fields" submitBtnText="sunmit me now"></vue-csv-import> 
    <p>{{ results }}</p>      
       </div>       


       <div  v-if="!isDisabled" class="col-md-12">
          <div v-if="!editMode">
             <a v-on:click="restart()" class="add cursor-pointer" > 
                     Restart Data  <i class="icon fas fa-refresh"/>
                    </a>

                  
       <h4>Pupils to Import</h4>   


       <h5 class="notice error" v-if="errored">You have errors in the data. Some results can not be imported</h5>


  {{selectedPupils.length}} Pupils
 <table class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm">
        <tr>
          <th></th>
            <th>Pupil Name</th>
            <th>Year</th>
            <th>Class</th>
            <th>Gender</th>
            <th>Ethnicity</th>
            <th>ESL</th>
            <th>SEN</th>
            <th>PP</th>
            <th align="right"></th>
        </tr>
        <tr class="course" v-for="(item, idx) in importData" :key="idx">
           <td class="selectable" @click="selectPupil(item)">
                                    <i class="far"  v-bind:class="[isSelected(item) ? 'fa-check-circle on' : 'fa-circle']"></i></td>
          <td  v-bind:class="isValid(item.name, idx)">{{item.name}}</td>
          <td v-bind:class="isValid(item.yeargroup, idx)">{{item.yeargroup}}</td>
          <td>{{item.class}}</td>
          <td v-bind:class="isValid(item.gender, idx)">{{item.gender}}</td>
          <td>{{item.ethnicity}}</td>
          <td><i class="fas"  v-bind:class="[item.english_second == 1 ? 'fa-check-circle active-true' : 'fa-times-circle active-false']"></i></td>
          <td>{{item.sen_status}}</td>
             <td><i class="fas"  v-bind:class="[item.premium_pupil == 1 ? 'fa-check-circle active-true' : 'fa-times-circle active-false']"></i></td>
           <td align="center" class="tb-actions">
                                    <a v-on:click="deletePupil(item, idx)" class="text-button red-text">Remove</a>
                                  </td>
        </tr>
    </table>
    <p v-if="isDisabled" style="color:#333;">There are no pupils to import</p>
    <button
                  type="button"
                  class="
                    mr-3
                    mt-4
                    mb-2
                    rounded
                    p-2
                    px-6
                    cursor-pointer
                    bg-action-blue bg-opacity-75 text-white
                    hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue
                  "    @click="processImportPupils"   v-show="!importDisabled"> Import {{selectedPupils.length}} Selected Pupils</button>

</div>
              
<div v-if="!editMode">
 <h4 style="margin-top:4em;">Possible Duplicates</h4>  
   {{duplicatePupils.length}} Pupils  
     <table class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm">
        <tr>
            <th>Pupil Name</th>
            <th>Year</th>
            <th>Class</th>
            <th>Gender</th>
            <th>Ethnicity</th>
            <th>ESL</th>
            <th>SEN</th>
            <th>PP</th>
            <th align="right"></th>
        </tr>
        <tr class="course" v-for="(item, idx) in duplicatePupils" :key="idx">
             <td  v-bind:class="isValid(item.name, idx)">{{item.name}}</td>
          <td v-bind:class="isValid(item.yeargroup, idx)">{{item.yeargroup}}</td>
          <td>{{item.inclass}}</td>
          <td v-bind:class="isValid(item.gender, idx)">{{item.gender}}</td>
          <td>{{item.ethnicity}}</td>
          <td><i class="fas"  v-bind:class="[item.english_second == 1 ? 'fa-check-circle active-true' : 'fa-times-circle active-false']"></i></td>
          <td>{{item.sen_status}}</td>
             <td><i class="fas"  v-bind:class="[item.premium_pupil == 1 ? 'fa-check-circle active-true' : 'fa-times-circle active-false']"></i></td>
              <td align="center" class="tb-actions">
                                  </td>
                    
        </tr>
    </table>
  </div>
</div>
 
   </div>

 
            </slot>
          </div>

          <div class="modal-footer">
               <slot name="footer">
            </slot>
          </div>
        </div>
      </div>
  
  </transition>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
 import VueCsvImport from "vue-csv-import";
 import { BaseService } from "@/services/school.service";


export default {
  name: 'register_import',
  props: ['registers', 'school'],
  computed: {
   // ...mapGetters({ currentUser: 'currentUser' }),
    isDisabled () {
      if (this.results.length > 0) {
        return false
      } else {
        return true
      }
    },
    importDisabled() {
      return this.selectedPupils.length == 0
    },
    importData() {
      let vm = this
      return vm.results.filter( ( el ) => !vm.duplicatePupils.includes( el ) );
    }
  },
  data () {
    return {
      duplicatePupils: [],
      parseCsv: [],
      selectedPupils: [],
      results: [],
      errored: false,
      editMode: false
    }
  },
 watch: {
   parseCsv: function () {
      let vm = this
      vm.parseCsv.forEach(function (pp, index) {

        let parseEAL = parseInt(pp.esl)
        let parsePremium = parseInt(pp.premium)

        let esl = (parseEAL == undefined || isNaN(parseEAL)) ? 0 : parseEAL
        let premium = (parsePremium == undefined || isNaN(parsePremium)) ? 0 : parsePremium
        let ethnicity = pp.ethnicity == undefined ? '' : pp.ethnicity
        let sen = pp.sen == undefined ? '' : pp.sen
        let classgroup = pp.group == undefined ? 'No Class' : pp.group
        let yeargroup = (pp.year == undefined || isNaN(pp.year)) ? undefined : pp.year
        let gender = pp.gender == undefined ? undefined : vm.getGender(pp.gender.toLowerCase().trim())

        let pupil = {
            name: pp.name,
            inclass: classgroup,
            gender: gender,
            yeargroup: yeargroup,
            ethnicity: ethnicity,
            english_second: esl,
            premium_pupil: premium,
            sen_status: sen,
            school_id: vm.school.id        
          }
        vm.results.push(pupil)
      })

      vm.checkImport()
   },
  },
  methods: {
    cancel () {
      this.$router.push({ name: 'SchoolEdit', params: {school: this.school }})
      window.scrollTo(0, 0);
    },
    checkImport () {

      var vm = this;
      vm.results.forEach(function (pupil, index) {
          let name = pupil.name.toLowerCase().trim().replace(/\s/g, "")
          var exists = vm.registers.filter(function(elem) {
            return elem.name.toLowerCase().trim().replace(/\s/g, "") == name
          })

          if (exists.length > 0) {
            vm.duplicatePupils.push(pupil)
          } else {
             vm.selectedPupils.push(pupil)
          }
      });
    },
    deletePupil(item, idx) {
      this.results.splice(idx, 1)
  },
     selectPupil(pupil) {
      if(this.selectedPupils.some(p => p.name === pupil.name && p.yeargroup == pupil.yeargroup)){
           this.selectedPupils.splice(this.selectedPupils.findIndex(item => item.name === pupil.name && item.yeargroup == pupil.yeargroup), 1)
      } else{
          this.selectedPupils.push(pupil)
     }
    },
    isSelected(pupil) {
      if(this.selectedPupils.some(p => p.name === pupil.name && p.yeargroup == pupil.yeargroup)){
          return true
      } else {
          return false
     }
   },
    isValid(value, idx) {
      if (value == undefined) {
        this.errored = true
        return 'valid-false' 
      } else {
        return 'valid-true'
     }
   },
   getGender(value) {
    if (value == 'f' || value == 'female') {
      return 'female'
    } else if (value == 'm' || value == 'male') {
        return 'male'
    } else {
      return undefined
    }
   },
   restart() {
    this.results = []
    this.selectedPupils = []
    this.parseCsv = []
    this.duplicatePupils = []
   },
   addToImport(pupil, index) {
    this.results.push(pupil)
    this.selectPupil(pupil)
   }, 
    completion (reload) {
      this.$emit('close')
    },
    failure (error) {
      this.errored = true
      //  this.$refs.saveNoticeTop.failed() 
      // this.$refs.saveNoticeBottom.failed() 
       console.log('Pupil update error ' + error);
    },
   processImportPupils() {
    let vm = this
    vm.selectedPupils.forEach(function (pupil, index) {
    pupil.yeargroup = parseInt(pupil.yeargroup)

    BaseService.create('archon/office/schools/'+ vm.school.id  + '/pupils', pupil)
         .then(response => vm.completion(false) )
        .catch((err) => {  vm.failure(err) })
    })
   }
  },
  components: {
    VueCsvImport
  }
}
</script>

<style scoped>

.row {
  margin-bottom: 11px;
}

textarea.form-control {
  height: 600px !important;
  max-height: 600px;
}

.right {
  float: right;
}

a.back {
   cursor: pointer !important;
}


.form-group input[type="file"], .import {
  background-color: red !important;
  opacity: 1 !important;
  position: relative !important;
}

  .tb-actions a, .selectable {
   cursor: pointer !important;
  }

  .selectable {
    padding-left:11px;
  }

.selectable i {
  font-size: 20px;
}

.selectable i.on {
  color: #f0ad4e !important;
}


.valid-false {
  background-color: red !important;
}

.error {
  color: red !important;
}

</style>